<template lang="html">
  <div class="col-12 p-0">
      <form class="form-detail-nameteam">
        <div class="form-group">
          <label for="teamName" class="font-weight-bold">Team Name</label>
          <GfInput        
            type="text"
            initial-field-value="" 
            place-holder="Enter team name"
            :has-error="validation.hasError('teamName')" 
            :error-text="validation.firstError('teamName')"            
            @valueChanged="(val) => teamName = val">
          </GfInput>
        </div>
        <div class="form-group">
          <label  class="font-weight-bold">Team Target</label>
          <div>
            <span class="currencyInput">$</span>
            <GfInput          
              type="text"
              additional-class="pl-3" 
              :initial-field-value="defaultTeamTarget" 
              place-holder="Team Target"
              :has-error="validation.hasError('teamTarget')" 
              :error-text="validation.firstError('teamTarget')"            
              @valueChanged="(val) => teamTarget = val">
            </GfInput>
          </div>
        </div>
          <div class="form-group pt-2">            
            <label class="checkbox-container">&nbsp; Also create an individual page?
              <input v-model="createIndividualPage" type="checkbox" />            
              <span class="checkmark"></span>
            </label>
          </div>        
      </form>
  </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import GfInput from '../inc/GfInput.vue';
var Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
  name: 'TeamDetails',

  components: { GfInput },

  data(){
    return {
        defaultTeamTarget: '800',
        teamName : '',
        teamTarget : '',
        createIndividualPage : this.$store.state.details_team.createIndividualPage
    }
  },

  watch:{
    teamName: function(val){
      if (val.length >= 1)
        this.$store.commit('teamNameChange', val);
      else
        this.$store.commit('teamNameChange', '');

      this.check_selected_detail();
      
    },
    teamTarget: function(val){
      if (this.isTargetValid(val))
        this.$store.commit('teamTargetChange', val);
      else
        this.$store.commit('teamTargetChange', '');

      this.check_selected_detail();
    },
    createIndividualPage: function(val){
      this.$store.commit('createIndividualPageChange',val);
    }
  },

  created(){    
    this.teamName = this.$store.state.details_team.teamName;
    if (!this.teamTarget || this.teamTarget === '')
      this.teamTarget = this.defaultTeamTarget;
    else
      this.teamTarget = this.$store.state.details_team.teamTarget;        
  },

  methods:{
    check_selected_detail(){
      if(this.teamName != '' || this.teamTarget != '' ){
        this.$store.commit('selected_details', 'details_team');
      }else{
        this.$store.commit('selected_details', '');
      }
    },

    isTargetValid: function(val) {
      return /^[0-9]+(\.)?[0-9]*$/.test(val);
    },

    next_step(){
      var vm = this;
      this.$validate().then(function(success) {
        if (success) {
          if(vm.$store.state.selected_charity == ''){
            vm.$router.push({name: 'charity_team' });
          }
          else if(vm.$store.state.selected_event == ''){
            vm.$router.push({name: 'Event_team' });
          }
          else{
            vm.$router.push({name: 'complete_team' });
          }
        }
      });
    }
  },
  
  validators: {
    teamName: function(teamName) {
      return Validator.value(teamName).required("You must enter a team name.").maxLength(20, "Name can not exceed 20 characters.");
    },
    teamTarget: function(teamTarget) {
      return Validator.value(teamTarget).required().float().lessThan(9999999, "Target must be less than $9,999,999");
    }
  }
}
</script>
<style scoped>
.currencyInput {
  position: absolute;
  margin-left: 3px;
  margin-top: 3px;  
  font-size: 18px;
}

.checkbox-container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;  
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #999;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 10px;
  top: 6px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>